<template>
  <section>
    <div class="role">
      <div class="roleRight">
        <div class="roleRight_Top" style="display: block">
          <template>
            <el-input
                clearable
                v-model="search.title"
                class="input_search"
                placeholder="搜索文章标题"
                style="margin-bottom: 10px;margin-right: 10px"
                @keyup.enter.native="SearchServiceList"
            ></el-input>

            <el-select
                v-model="search.categoryId"
                clearable
                filterable
                placeholder="选择分类"
                style="margin-bottom: 10px;margin-right: 10px"
            >
              <el-option
                  v-for="item in categoryList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              ></el-option>
            </el-select>

            <el-select
                v-model="search.isOffline"
                clearable
                filterable
                placeholder="文章状态"
                style="margin-bottom: 10px;margin-right: 10px"
            >
              <el-option
                  v-for="item in ARTICLE_STATUS"
                  :key="item.key"
                  :label="item.name"
                  :value="item.key"
              ></el-option>
            </el-select>

            <el-select
                v-model="search.articleType"
                clearable
                filterable
                placeholder="文章类型"
                style="margin-bottom: 10px;margin-right: 10px"
            >
              <el-option
                  v-for="item in ARTICLE_TYPE"
                  :key="item.key"
                  :label="item.name"
                  :value="item.key"
              ></el-option>
            </el-select>

            <el-button size="medium" type="primary" @click="SearchServiceList"
            >查询</el-button
            >
            <el-button size="medium" @click="handleReset"
            >重置</el-button
            >
          </template>
          <el-button v-if="addShow" size="medium" type="primary" @click="handleAdd"
          >新增文章</el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table
            :data="tableData"
            size="medium"
            border
            style="width: 100%"
            v-loading="loading"
          >
            <el-table-column fixed label="序号" type="index" width="60">
              <template slot-scope="scope">
                <span>{{ (page.pageNo - 1) * page.pageSize + scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column fixed label="封面" type="picUrl" width="60">
              <template slot-scope="scope">
                <img :src="scope.row.picUrl" alt="封面" style="width: 40px; height: 40px;">
              </template>
            </el-table-column>

            <el-table-column label="文章信息" min-width="300">
              <template slot-scope="scope">
                <div style="text-align: left;">
                  <div style="font-weight: bold; font-size: 14px; margin-bottom: 5px;">
                    {{ scope.row.title || '-' }}
                  </div>
                  <div style="color: #666; font-size: 12px;">
                    描述：{{ scope.row.description || '-' }}
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="分类信息" width="120">
              <template slot-scope="scope">
                <div>{{ scope.row.categoryName || '-' }}</div>
              </template>
            </el-table-column>

            <el-table-column label="文章类型" width="100">
              <template slot-scope="scope">
                <el-tag :type="getArticleTypeTag(scope.row.articleType)" size="mini">
                  {{ getArticleTypeText(scope.row.articleType) }}
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column label="状态" width="100">
              <template slot-scope="scope">
                <el-tag :type="scope.row.isOffline === 0 ? 'success' : 'danger'" size="mini">
                  {{ scope.row.isOffline === 0 ? '上架' : '下架' }}
                  </el-tag>
              </template>
            </el-table-column>

            <el-table-column label="阅读次数" prop="pvCount" width="100" align="center"></el-table-column>

            <el-table-column label="排序" width="100" align="center">
              <template slot-scope="scope">
                <InlineTableControler
                  v-model="scope.row.sortOrder"
                  type="number"
                  valueKey="sortOrder"
                  customApi="/article/infos/save"
                  :disabled="!editShow"
                  :params="scope.row"
                  @refresh="getArticleList"
                />
              </template>
            </el-table-column>

            <el-table-column label="上架" width="80" align="center">
              <template slot-scope="scope">
                <InlineTableControler
                  v-model="scope.row.isOffline"
                  valueKey="isOffline"
                  customApi="/article/infos/save"
                  :active-value="0"
                  :inactive-value="1"
                  activeColor="#13ce66"
                  inactiveColor="#ff4949"
                  :disabled="!statusShow"
                  :params="scope.row"
                  @refresh="getArticleList"
                />
              </template>
            </el-table-column>

            <el-table-column label="推送" width="80" align="center">
              <template slot-scope="scope">
                <InlineTableControler
                  v-model="scope.row.isPush"
                  valueKey="isPush"
                  customApi="/article/infos/save"
                  :active-value="1"
                  :inactive-value="0"
                  activeColor="#409EFF"
                  inactiveColor="#909399"
                  :disabled="!statusShow"
                  :params="scope.row"
                  @refresh="getArticleList"
                />
              </template>
            </el-table-column>

            <el-table-column label="时间信息" min-width="200">
              <template slot-scope="scope">
                <div style="font-size: 12px;">
                  <div>发布：{{ formatDate(scope.row.publishDate) }}</div>
                  <div>创建：{{ formatDate(scope.row.ctime) }}</div>
                  <div>更新：{{ formatDate(scope.row.utime) }}</div>
                </div>
              </template>
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="180">
              <template slot-scope="scope">
                <el-button
                  @click="handleEdit(scope.row)"
                  type="text"
                  size="small"
                  v-if="editShow"
                >
                  编辑
                </el-button>

                <el-button
                  @click="handleDetail(scope.row)"
                  type="text"
                  size="small"
                  v-if="detailShow"
                >
                  详情
                </el-button>

                <el-button
                  @click="handleDelete(scope.row)"
                  type="text"
                  size="small"
                  style="color: #f56c6c"
                  v-if="deleteShow"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>

          </el-table>
        </div>

        <div class="roleRight_pagenation">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.pageNo"
            :page-sizes="[PAGE_SIZE, 15, 20, 25]"
            :page-size="page.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 详情弹窗 -->
    <MultiLanguageDetailDialog
      ref="detailDialog"
      title="文章详情"
      width="1000px"
      :detail-api-template="'/article/infos/detail/{id}'"
    />

    <MultiLanguageEditDialog
      :fullscreen="true"
      ref="editDialog"
      title="文章编辑"
      :api="'/article/infos/save'"
      :detail-api-template="'/article/infos/detail/{id}'"
      @success="getArticleList"
    />
  </section>
</template>
<script>
import {
  PAGE_SIZE,
} from "@/config";
import { formatDate } from "@/utils/filters/filter";
import MultiLanguageDetailDialog from "@/components/MultiLanguageDetailDialog.vue";
import MultiLanguageEditDialog from '@/components/MultiLanguageEditDialog.vue';
import InlineTableControler from '@/components/InlineTableControler.vue';
export default {
  components: {
    MultiLanguageDetailDialog,
    MultiLanguageEditDialog,
    InlineTableControler,
  },
  data() {
    return {
      PAGE_SIZE,
      formatDate, 
      
      // 文章状态选项
      ARTICLE_STATUS: [
        { key: 0, name: '上架' },
        { key: 1, name: '下架' }
      ],
      
      // 文章类型选项
      ARTICLE_TYPE: [
        { key: 'news', name: '新闻' },
        { key: 'text', name: '文本' },
        { key: 'image', name: '图片' },
        { key: 'audio', name: '音频' },
        { key: 'video', name: '视频' }
      ],

      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
        count: 0
      },

      categoryList: [], // 分类列表
      tableData: [], // 文章列表数据
      loading: false,
      search: {},

      // 权限控制
      searchShow: true,
      addShow: true,
      editShow: true,
      deleteShow: true,
      statusShow: true,
      detailShow: true,

      editDialog: null,

      // 多语言相关
      languageList: [],
      currentLanguageCode: 'en'
    };
  },
  created() {
    this.getCategoryList();
    this.getArticleList();
    this.getPermissionButtonList();
    this.getLanguageList();
  },
  methods: {
    // 获取分类列表
    async getCategoryList() {
      try {
        const { data: res } = await this.$post(
          `/article/category/list`,
          { 
            pageNo: 1, 
            pageSize: 1000 
          }
        );
        if (res && res.data) {
          this.categoryList = res.data;
          console.log('分类列表获取成功:', this.categoryList);
        }
      } catch (error) {
        console.error('获取分类列表失败:', error);
      }
    },

    // 获取权限按钮列表
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton');
      if (PermissionButtonList) {
        try {
          let arr = JSON.parse(PermissionButtonList);
          // 确保arr是数组
          if (arr && Array.isArray(arr) && arr.length) {
            arr.forEach(item => {
              if (item.code === 'article:management:query') {
                this.searchShow = true;
              }
              if (item.code === 'article:management:add') {
                this.addShow = true;
              }
              if (item.code === 'article:management:edit') {
                this.editShow = true;
              }
              if (item.code === 'article:management:delete') {
                this.deleteShow = true;
              }
              if (item.code === 'article:management:status') {
                this.statusShow = true;
              }
              if (item.code === 'article:management:detail') {
                this.detailShow = true;
              }
            });
          }
        } catch (error) {
          console.error('权限按钮列表解析失败:', error);
        }
      }
    },

    // 搜索
    SearchServiceList() {
      this.page.pageNo = 1;
      this.getArticleList();
    },

    // 获取文章列表
    async getArticleList() {
      this.loading = true;
      let _search={};
      for(let key in this.search){
        if(this.search[key]!==""){
          _search[key]=this.search[key];
        }
      }

      try {
        const { data: res } = await this.$post(
          `/article/infos/list`,
          { 
            ..._search, 
            pageNo: this.page.pageNo,
            pageSize: this.page.pageSize
          },
          {
            headers: {
              isLoading: true,
            },
          }
        );
        
        if (res) {
          this.tableData = res.data || [];
          this.page.count = res.page && res.page.count ? res.page.count : 0;
        }else{
          this.tableData = [];
          this.page.count = 0;
        }
      } catch (error) {
        console.error('获取文章列表失败:', error);
        this.$message.error('获取文章列表失败');
      } finally {
        this.loading = false;
      }
    },

    // 新增文章
    handleAdd() {
      if (!this.$refs.editDialog) return;
      this.$refs.editDialog.open({}, this.getBasicColumns(), {
        api: '/article/infos/save',
        method: 'post',
      });
    },

    // 编辑文章
    async handleEdit(row) {
      if (!this.$refs.editDialog) return;

      // 直接使用列表数据进行编辑，多语言组件会自动获取默认语言的详情数据
      const editData = {
        ...row,
        // 确保分类ID存在，如果没有则尝试从分类列表中查找
        categoryId: row.categoryId || this.getCategoryIdByName(row.categoryName)
      };
      
      this.$refs.editDialog.open(editData, this.getBasicColumns(), { 
        api: '/article/infos/save', 
        method: 'post',
      });
    },

    // 查看详情
    async handleDetail(row) {
      if (!this.$refs.detailDialog) {
        console.error('DetailDialog组件未找到');
        this.$message.error('详情组件加载失败，请刷新页面重试');
        return;
      }
      const basicColumns = [
        { label: '标题', prop: 'title', type: 'text', span: 2 },
        { label: '封面图', prop: 'picUrl', type: 'image' },
        { label: '描述', prop: 'description', type: 'text', span: 2 },
        { label: '分类', prop: 'categoryName', type: 'text' },
        { label: '文章类型', prop: 'articleType', type: 'tag', tagMap: {
          'news': { text: '新闻', type: 'primary' },
          'text': { text: '文本', type: 'success' },
          'image': { text: '图片', type: 'warning' },
          'audio': { text: '音频', type: 'info' },
          'video': { text: '视频', type: 'danger' }
        }},
        { label: '点击地址', prop: 'url', type: 'link', linkText: '查看文章' },
        { label: '排序', prop: 'sortOrder', type: 'text' },
        { label: '状态', prop: 'isOffline', type: 'tag', tagMap: {
          0: { text: '上架', type: 'success' },
          1: { text: '下架', type: 'danger' }
        }},
        { label: '发布日期', prop: 'publishDate', type: 'date' ,required:true},
        { label: '阅读次数', prop: 'pvCount', type: 'text' },
        { label: '推送状态', prop: 'isPush', type: 'tag', tagMap: {
          1: { text: '已推送', type: 'success' },
          0: { text: '未推送', type: 'info' }
        }},
      ];
      const contentColumns = [
        { label: '文章内容', prop: 'content', type: 'html', span: 2 }
      ];
      const tabsConfig = [
        {
          label: '基础信息',
          name: 'basic',
          columns: basicColumns
        },
        {
          label: '文章详情',
          name: 'content',
          columns: contentColumns
        }
      ];
      this.$refs.detailDialog.openTabsByApi(
        `/article/infos/detail/${row.id}`,
        {},
        tabsConfig,
        // tabsConfig.map(config => ({
        //   ...config,
        //   preProcessData: (apiData) => ({
        //     ...row,
        //     content: (apiData && apiData.content) || '',
        //     articleId: (apiData && apiData.articleId) || row.id
        //   })
        // })),
        {
          // enableMultiLanguage: true,
          // languageList: this.languageList,
          originalData: row
        }
      );
    },

    // 删除文章
    async handleDelete(row) {
      try {
        await this.$confirm('确定要删除这篇文章吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        
        // 调用删除接口
        await this.$get(`/article/infos/delete/${row.id}`);
        this.$message.success('删除成功');
        this.getArticleList();
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除失败:', error);
          this.$message.error('删除失败');
        }
      }
    },

    // 分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getArticleList();
    },
    
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getArticleList();
    },

    // 获取文章类型标签颜色
    getArticleTypeTag(type) {
      const tagMap = {
        'news': 'primary',
        'text': 'success',
        'image': 'warning',
        'audio': 'info',
        'video': 'danger'
      };
      return tagMap[type] || '';
    },

    // 获取文章类型文本
    getArticleTypeText(type) {
      const textMap = {
        'news': '新闻',
        'text': '文本', 
        'image': '图片',
        'audio': '音频',
        'video': '视频'
      };
      return textMap[type] || type;
    },

    // 重置搜索条件
    handleReset() {
      this.search = {};
      this.page.pageNo = 1;
      this.getArticleList();
    },

    getBasicColumns() {
      return [
        // { label: 'ID', prop: 'id', type: 'text', addHide: true },
        { label: '标题', prop: 'title', type: 'text', required: true },
        { label: '分类', prop: 'categoryId', type: 'select', options: this.categoryList, required: true },
        { label: '文章类型', prop: 'articleType', type: 'select', options: this.ARTICLE_TYPE, required: true },
        { label: '封面图', prop: 'picUrl', type: 'image' },
        { label: '描述', prop: 'description', type: 'textarea', },
        { label: '点击地址', prop: 'url', type: 'text' },
        { label: '排序', prop: 'sortOrder', type: 'number' },
        { label: '是否下架', prop: 'isOffline', type: 'switch' },
        { label: '发布日期', prop: 'publishDate', type: 'date' },
        { label: '阅读次数', prop: 'pvCount', type: 'number', hide: true },
        { label: '推送状态', prop: 'isPush', type: 'switch', addHide: true },
        // { label: '是否删除', prop: 'isDelete', type: 'switch', addHide: true },
        { label: '创建时间', prop: 'ctime', type: 'date', hide: true, addHide: true, editHide: true },
        { label: '更新时间', prop: 'utime', type: 'date', hide: true, addHide: true, editHide: true },
        { label: '文章内容', prop: 'content',type: 'richText',required: true,span:3, },
        ];
    },

    // 获取语言列表
    async getLanguageList() {
      try {
        const { data: res } = await this.$post('/language/list', {
          adminStatus: 1
        });
        if (res && res.data) {
          this.languageList = res.data;
          this.currentLanguageCode = (res.data[0] && res.data[0].code) || 'en';
        }
      } catch (error) {
        console.error('获取语言列表失败:', error);
      }
    },

    // 根据分类名称获取分类ID
    getCategoryIdByName(categoryName) {
      if (!categoryName || !this.categoryList) return null;
      const category = this.categoryList.find(cat => cat.name === categoryName);
      return category ? category.id : null;
    },
  },
};
</script>

<style lang="scss" scoped>
.role {
  display: flex;
  gap: 20px;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;
  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;
    &_Top {
      display: flex;
      gap: 15px;
      .el-input {
        width: auto;
      }
      .timeblock {
        display: flex;
        box-sizing: border-box;
        background: #fff;
        border: 1px solid #dcdfe6;
        border-radius: 5px;
        .cla ::v-deep .el-input--suffix .el-input__inner {
          padding-right: 0;
        }
        ::v-deep .el-input__inner {
          border: none !important;
          height: 38px;
        }
      }
    }
    &_Container {
      margin-top: 20px;
    }
    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}
</style>